export const TUTORIAL_STORAGE_KEY = 'finance_engine_v2_tutorial';

export enum TutorialStatus {
  NOT_STARTED = 'not_started',
  SKIPPED = 'skipped',
  COMPLETED = 'completed',
  IN_PROGRESS = 'in_progress',
}

export const FREQUENCY_OPTIONS = [
  { label: 'Weekly', value: 'WEEKLY' },
  { label: 'Fortnightly', value: 'FORTNIGHTLY' },
  { label: 'Monthly', value: 'MONTHLY' },
];

export const FREQUENCY_COLORS: Record<string, string> = {
  WEEKLY: 'blue',
  FORTNIGHTLY: 'green',
  MONTHLY: 'gold',
};

export const VARIABLE_ORIGIN_OPTIONS = [
  { label: 'Booking', value: 'BOOKING' },
  { label: 'MRR', value: 'MRR' },
];

export const TAB_KEYS = {
  PLANS: 'plans',
  VARIABLES: 'variables',
  CONCEPTS: 'concepts',
  INVOICES: 'invoices',
};

export const INVOICE_STATUS_OPTIONS = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Failed', value: 'FAILED' },
  { label: 'Cancelled', value: 'CANCELLED' },
];

export const INVOICE_STATUS_COLORS: Record<string, string> = {
  PENDING: 'gold',
  COMPLETED: 'green',
  FAILED: 'red',
  CANCELLED: 'default',
  EXPIRED: 'volcano',
};

export const INVOICE_TYPE_OPTIONS = [
  { label: 'Booking', value: 'BOOKING' },
  { label: 'MRR', value: 'MRR' },
  { label: 'MRR Partial', value: 'MRR_PARTIAL' },
];

export const GATEWAY_OPTIONS = [
  { label: 'Paymentez', value: 'PAYMENTEZ' },
  { label: 'Stripe', value: 'STRIPE' },
  { label: 'Epayco', value: 'EPAYCO' },
];
